import { render } from "./Clock.vue?vue&type=template&id=7e0c921c"
import script from "./Clock.vue?vue&type=script&lang=js"
export * from "./Clock.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "7e0c921c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e0c921c', script)) {
    api.reload('7e0c921c', script)
  }
  
  module.hot.accept("./Clock.vue?vue&type=template&id=7e0c921c", () => {
    api.rerender('7e0c921c', render)
  })

}

script.__file = "src/icons/components/outlined/Clock.vue"

export default script